const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景圖片 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/99235c4c62ca63234113ff3cc7faeee7.jpg"
          alt="數位科技與遊戲創新"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* 內容 */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          數位科技與創新服務
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
            領導品牌
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
          專注於<strong>遊戲產品代理</strong>、<strong>研發與市場推廣</strong>
          <br />
          鏈結創意與玩家體驗，打造卓越的遊戲產業生態
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#services"
            className="bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            探索我們的服務
          </a>
          <a 
            href="#contact"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap"
          >
            聯繫我們
          </a>
        </div>

        {/* 特色標籤 */}
        <div className="mt-16 flex flex-wrap justify-center gap-6">
          <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <span className="text-white font-medium">🎮 遊戲代理</span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <span className="text-white font-medium">💡 產品研發</span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <span className="text-white font-medium">📈 市場推廣</span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <span className="text-white font-medium">🌟 玩家體驗</span>
          </div>
        </div>
      </div>

      {/* 滾動提示 */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <a href="#about" className="flex flex-col items-center text-white hover:text-orange-400 transition-colors">
          <span className="text-sm mb-2">向下探索</span>
          <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
